import { render, staticRenderFns } from "./UnlockOfferButton.vue?vue&type=template&id=80f36e52&scoped=true"
import script from "./UnlockOfferButton.vue?vue&type=script&lang=ts"
export * from "./UnlockOfferButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f36e52",
  null
  
)

export default component.exports